import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "../components/product/ProductCard";
import { useStore } from "../context/StoreContext";

const WishlistPage = () => {
  const { wishlist, products } = useStore();
  const items = products.filter((p) => wishlist.includes(p.id));

  return (
    <div data-testid="page-wishlist" className="pt-[100px] pb-16">
      <div className="max-w-[1440px] mx-auto px-4 md:px-12">
        <div className="flex items-baseline gap-4 mb-10">
          <h1 className="font-display uppercase text-5xl sm:text-7xl md:text-8xl leading-none">
            Saved
          </h1>
          <span className="font-mono text-xs uppercase tracking-widest text-ink/60">
            {String(items.length).padStart(2, "0")} ITEMS
          </span>
        </div>

        {items.length === 0 ? (
          <div className="text-center py-20" data-testid="wishlist-empty">
            <p className="font-mono uppercase tracking-widest text-ink/70">
              NOTHING SAVED YET.
            </p>
            <Link
              to="/shop"
              className="inline-block mt-6 btn-solid"
              data-testid="wishlist-browse"
            >
              Browse shop &rarr;
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
            {items.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WishlistPage;
